import * as Subtitle from "@splayer/subtitle";
import { ClipsList, getWordsFromSegment } from "./clips";

interface SubtitleSegment {
  start: number;
  end: number;
  text: string;
}

export const getSegmentsFromSrt = ({ srt }: { srt: string }) => {
  const parsed = Subtitle.parse(srt) as SubtitleSegment[];
  const clipList = new ClipsList();
  parsed.forEach((segment: SubtitleSegment) => {
    const start = segment.start / 1000;
    const end = segment.end / 1000;
    const text = segment.text;
    const words = getWordsFromSegment({
      text,
      start,
      end,
    });
    clipList.add(text, start, end, "original", words);
  });
  return clipList;
};

export const timeMsToSrt = ({
  timeMs,
  includeMillis = false,
  stripZeroes = true,
  keepMinutes = false,
}: {
  timeMs: number;
  includeMillis?: boolean;
  stripZeroes?: boolean;
  keepMinutes?: boolean;
}) => {
  const date = new Date(timeMs);
  const hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  const seconds = date.getUTCSeconds();
  const milliseconds = date.getUTCMilliseconds();
  let result = `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}:${seconds.toString().padStart(2, "0")},${milliseconds
    .toString()
    .padStart(3, "0")}`;
  if (!includeMillis) {
    result = `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  }
  if (stripZeroes) {
    if (keepMinutes) {
      result = result.replace(/^00:/, "");
    } else {
      result = result.replaceAll("00:", "").replace(/^0/, "");
    }
  }
  return result;
};
